import { compose, setDisplayName } from 'react-recompose';

import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import { fetchOrganization } from '~/state/ducks/organizations/operations';
import { getOrgData } from '~/state/ducks/organizations/selectors';

import OrganizationView from '../components/OrganizationView';


export default compose(
    setDisplayName('OrganizationsViewContainer'),
    withReduxDataLoading({
        name: 'fetchOrganization',
        operation: ({ match: { params: { id } } }) => fetchOrganization(id),
        selector: getOrgData,
    }),
    withLoadingBranch,
)(OrganizationView);
